
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-all-question-modal',
  templateUrl: './all-question-modal.component.html',
  styleUrls: ['./all-question-modal.component.scss']
})
export class AllQuestionModalComponent implements OnInit {


  // lstAllQuestions = [
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   },
  //   {
  //     banner: 'assets/images/no-poverty.png',
  //     heading: 'No poverty',
  //     badge: ['Silver badge', 'assets/images/silver-badge.png'],
  //     score: { 'current_score': 220, 'total_score': 240 },
  //     questions: { 'completed': 17, 'total': 17 }
  //   }
  // ]

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AllQuestionModalComponent>,
    public router: Router,
    // public loaderService: LoaderService,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data) {
    // this.data.forEach(sdg => {
    //   sdg.info.percentage = Math.round((sdg.info.answered_questions / sdg.info.total_questions) * 100);
    // });
    console.log(this.data);
  }

  ngOnInit(): void {
    // this.loaderService.display(true);
  }

  viewQuestion(question) {
    this.dialogRef.close(question)
  }

  close() {
    this.dialogRef.close()
  }

}
